<template>
	<div>
		<modal ref="modal" name="cp-modal-assinatura" style="z-index: 9999999">
			<div class="row">
				<div class="col-md-4 col-xs-12 text-center">
					<span
						class="fa-stack fa-lg"
						:class="{'icon-ass': !_isMobile, 'icon-ass-mobile': _isMobile}"
					>
						<i class="fa fa-circle fa-stack-2x"></i>
						<i class="fa fa-lock fa-stack-1x fa-inverse"></i>
					</span>
				</div>

				<div class="col-md-8 col-xs-12">
					<h3
						:class="{'text-center': _isMobile}"
						style="color: #2196f3; margin-top: 10px"
					>
						{{ _traducao('global', 'assinatura').toUpperCase() }}
					</h3>
					<div class="form-group" :class="{'has-error': erroAssinatura}">
						<label>{{ _traducao('global', 'digiteSuaAssinatura') }}: </label>
						<div
							class="fa icone-senha"
							:class="{'fa-eye-slash': inputSenha, 'fa-eye': !inputSenha}"
							title="Clique para ver a assinatura"
							@click="inputSenha = !inputSenha"
							aria-hidden="true"
						></div>
						<input
							v-show="inputSenha"
							type="text"
							v-model="assinatura"
							class="form-control input-sm"
						/>
						<input
							v-show="!inputSenha"
							ref="ip"
							type="password"
							v-model="assinatura"
							class="form-control input-sm"
						/>
						<!--<input v-model="senha" type="password" class="form-control input-sm" /> -->
						<p class="help-block" v-show="erroAssinatura">
							{{ _traducao('global', 'assinaturaInvalida') }}
						</p>
					</div>
				</div>
			</div>

			<hr style="margin-top: 20px; margin-bottom: 10px" />

			<div class="row">
				<div class="col-xs-6">
					<button
						class="btn btn-default pull-left"
						type="button"
						@click="clickFechar()"
					>
						<i class="fa fa-times"></i>
						{{ _traducao('global', 'fechar').toUpperCase() }}
					</button>
				</div>

				<div class="col-xs-6">
					<button
						class="btn btn-success pull-right"
						:disabled="assinatura == ''"
						type="button"
						@click="clickAssinar()"
					>
						<i class="fa fa-check"></i>
						{{ _traducao('global', 'assinar').toUpperCase() }}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>

<style>
.icon-ass {
	margin-top: 63px;
	font-size: 76px;
	color: #2196f3;
	opacity: 0.7;
}

.icon-ass-mobile {
	font-size: 50px;
	color: #2196f3;
	opacity: 0.7;
}
</style>

<script>
export default {
	props: {
		retornaSenha: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data: function () {
		return {
			qtdTentativas: 0,
			texto: '',
			assinatura: '',
			erroAssinatura: '',
			inputSenha: false,
			data: {},
			loadText: '',
			token: ''
		}
	},

	mounted() {},

	methods: {
		carregaAssinatura(data, texto) {
			this.qtdTentativas = 1
			this.assinatura = ''
			this.data = data
			this.erroAssinatura = false
			this.validaSenha = false
			this.$refs.modal.modalShow(40)
			this.loadText = 'Assinando'
			if (!_.isNil(texto)) {
				this.loadText = texto
			}

			setTimeout(() => this.$refs.ip.focus(), 600)
		},

		carregaAssinaturaExterna(data, token) {
			this.qtdTentativas = 1
			this.assinatura = ''
			this.data = data
			this.token = token
			this.erroAssinatura = false
			this.validaSenha = false
			this.$refs.modal.modalShow(40)
			this.loadText = 'Assinando'

			setTimeout(() => this.$refs.ip.focus(), 600)
		},

		clickFechar() {
			this.$refs.modal.modalHide()
			this.$emit('fechou')
		},

		//LOOP ASSINATURA DIARIO DE BORDO OPERADOR
		assinar(callback, data, senha, text) {
			if (text != '') {
				bus.$emit('load-in', {text: text})
			}

			let dt = {
				id_usuario: $sessao.getId(),
				assinatura: senha,
				data: data,
				tentativas: 1
			}

			this._httpPost('Assinatura/assinar', dt, (response) => {
				if (text != '') {
					bus.$emit('load-out')
				}

				if (response._request && response._status) {
					callback({assinatura: response.lista, data: data})
				}
			})
		},

		clickAssinar() {
			if (this.token != '' && this.token != null) {
				this.assinarExterno()
			} else {
				this.assinarInterno()
			}
		},

		assinarExterno() {
			bus.$emit('load-in', {text: this.loadText})

			var data = {
				id_usuario: this.data.id_usuario,
				assinatura: this.assinatura,
				data: this.data,
				tentativas: this.qtdTentativas
			}

			this._httpPost(
				'Assinatura/assinar',
				data,
				(response) => {
					bus.$emit('load-out')
					if (response._request) {
						if (response._status) {
							this.$refs.modal.modalHide()
							if (this.retornaSenha) {
								this.$emit('assinado', {
									assinatura: response.lista,
									data: this.data,
									senha: this.assinatura
								})
							} else {
								this.$emit('assinado', {
									assinatura: response.lista,
									data: this.data
								})
							}
						} else {
							this.erroAssinatura = true
							this.qtdTentativas += 1
						}
					}
				},
				this.token
			)
		},

		assinarInterno() {
			bus.$emit('load-in', {text: this.loadText})

			var data = {
				id_usuario: $sessao.getId(),
				assinatura: this.assinatura,
				data: this.data,
				tentativas: this.qtdTentativas
			}

			this._httpPost('Assinatura/assinar', data, (response) => {
				bus.$emit('load-out')
				if (response._request) {
					if (response._status) {
						this.$refs.modal.modalHide()
						if (this.retornaSenha) {
							this.$emit('assinado', {
								assinatura: response.lista,
								data: this.data,
								senha: this.assinatura
							})
						} else {
							this.$emit('assinado', {
								assinatura: response.lista,
								data: this.data
							})
						}
					} else {
						this.erroAssinatura = true
						this.qtdTentativas += 1
					}
				}
			})
		}
	}
}
</script>

<style>
.keybord a {
	padding: 30px;
}
</style>